import type { Clock } from './Clock';

// The ONE place in @sl/core and the apps that may read the system time: eslint.config.mjs exempts this file
// from the D-020 rule, and nothing else. Everything else receives a Clock (default = this one).
export const systemClock: Clock = {
  now: () => Date.now(),
};
